function createEsriDynamicLayer(featureViewTitle, type, id, pipeFieldMapping, zoomLevelHint = '(比例尺50m)'){
	var toast_sleep = false
	toast_open("資訊中心圖層介接中，建議放大地圖使用" + zoomLevelHint)
	var layer = L.esri.dynamicMapLayer({
		url: 'https://gis1.ntpc.gov.tw/GIS/rest/services/' + type + '/MapServer',
		token: 'jhT4NH8RE59H2tM-90uRfXk-IWCduZs9v9CHDZkxXkukmb68EXmexR5kp8ar66I9',
		layers: [id],
		disableCache: false,
		f: 'json',
		pane: "high-zindex-wms-layer",
		giLevel: 5
	}).on('loading', function(e){
		if (zoomLevelHint !== '' && !toast_sleep) {
			// toast_open("資訊中心圖層介接中，建議放大地圖使用" + zoomLevelHint)
			toast_sleep = true
			setTimeout(() => {
				toast_sleep = false
			}, 3000)
		}
	})
    layer.bindPopup(function (error, featureCollection) {
		if (error || featureCollection.features.length === 0) {
			return false;
		} else {
			var html = ''
			Object.keys(featureCollection.features[0].properties).forEach(function(key){
				if (pipeFieldMapping[key]) {
					if (pipeFieldMapping[key] === '尺寸' || pipeFieldMapping[key] === '尺寸單位') {
						let SizeUnit = ''
						switch (featureCollection.features[0].properties[key]) {
							case '0':
								SizeUnit = 'mm'
								break
							case '1':
								SizeUnit = 'inch'
								break
							case '2':
								SizeUnit = 'cm'
								break
							case '3':
								SizeUnit = 'm'
								break
						}
						html += `<tr><td>${pipeFieldMapping[key]}</td><td>${SizeUnit}</td></tr>`
					} else {
						html += `<tr><td>${pipeFieldMapping[key]}</td><td>${featureCollection.features[0].properties[key]}</td></tr>`
					}
				}
			})
			console.log(layer)
			html = '<table class="table table-sm table-bordered w-100"><thead class="thead-dark"><tr><th>欄位名稱</th><th>欄位敘述</th></tr></thead><tbody>' + html + '</tbody></table>'
			modal_open(html, featureViewTitle)
		}
    })
	return layer
}

// 瓦斯孔蓋
function get_ntpcgis_gas_pipe_manhole(){
	let pipeField = {
		"BaseHeight": "基礎高度",
		"BuildDate": "建造日期",
		"CategCode": "Categ代碼",
		"CORRECTION": "校正",
		"CoverType": "孔蓋類別",
		"CoverWidth": "孔蓋寬度",
		"CovHeight": "孔蓋高度",
		"CreateTime": "建立時間",
		"DataStatus": "資料狀態",
		"FacNum": "Fac號碼",
		"FID_Land": "FID_土地",
		"FID_RoadBlk": "FID_道路Blk",
		"HoleDepth": "孔洞深度",
		"HoleID": "孔洞編號",
		"LastModify": "最後修改",
		"Memo": "備註",
		"MendTime": "時間",
		"OPCode": "作業區分",
		"Organ": "單位",
		"PContent": "內容物",
		"ROW_STATUS": "狀態",
		"SetType": "類型",
		"SizeUnit": "尺寸",
		"STATE": "狀態",
		"Sys_Key": "代碼",
		"TCode": "編碼",
		"UseStatus": "使用狀態",
		"ZValueInfo": "Z值資訊"
	}
    let layer = createEsriDynamicLayer('瓦斯孔蓋', 'PubPipe', 10, pipeField)
    return layer
}

// 電信管線
function get_ntpcgis_telecom_pipeline(){
	let pipeField = {
		"OBJECTID": "流水號",
		"Sys_Key": "系統編號",
		"CreateTime": "建立時間",
		"LastModify": "修改時間",
		"ROW_STATUS": "使用狀態",
		"CategCode": "類別碼",
		"FacNum": "識別碼",
		"StartNum": "起點編號",
		"EndNum": "終點編號",
		"Organ": "管理單位",
		"OPCode": "作業分區",
		"BuildDat": "設置日期",
		"PipeID": "管線編號",
		"SizeUnit": "尺寸單位",
		"PipeWidth": "管徑寬度",
		"PipeHeight": "管徑高度",
		"CulvertNum": "涵管條數",
		"PMaterial": "管線材料",
		"StartDepth": "起點埋設深度(M)",
		"EndDepth": "終點埋設深度(M)",
		"PipeLength": "管線長度",
		"SetType": "管線型態",
		"UseStatus": "使用狀態",
		"DataStatus": "資料狀態",
		"Memo": "備註"
	}
	let layer = createEsriDynamicLayer('電信管線', 'PubPipe', 0, pipeField)
    return layer
}

// 電力管線
function get_ntpcgis_electricity_pipeline(){
	let pipeField = {
		"OBJECTID": "流水號",
		"Sys_Key": "系統編號",
		"CreateTime": "建立時間",
		"LastModify": "修改時間",
		"ROW_STATUS": "使用狀態",
		"CategCode": "類別碼",
		"FacNum": "識別碼",
		"StartNum": "起點編號",
		"EndNum": "終點編號",
		"Organ": "管理單位",
		"OPCode": "作業分區",
		"BuildDat": "設置日期",
		"PipeID": "管線編號",
		"SizeUnit": "尺寸單位",
		"PipeWidth": "管徑寬度",
		"PipeHeight": "管徑高度",
		"CulvertNum": "涵管條數",
		"PMaterial": "管線材料",
		"StartDepth": "起點埋設深度(M)",
		"EndDepth": "終點埋設深度(M)",
		"PipeLength": "管線長度",
		"SetType": "管線型態",
		"UseStatus": "使用狀態",
		"DataStatus": "資料狀態",
		"Memo": "備註"
	}
	let layer = createEsriDynamicLayer('電力管線', 'PubPipe', 2, pipeField)
    return layer
}

// 自來水管線
function get_ntpcgis_water_pipeline(){
	let pipeField = {
		"OBJECTID": "流水號",
		"Sys_Key": "系統編號",
		"CreateTime": "建立時間",
		"LastModify": "修改時間",
		"ROW_STATUS": "使用狀態",
		"CategCode": "類別碼",
		"FacNum": "識別碼",
		"StartNum": "起點編號",
		"EndNum": "終點編號",
		"Organ": "管理單位",
		"OPCode": "作業分區",
		"BuildDat": "設置日期",
		"PipeID": "管線編號",
		"SizeUnit": "尺寸單位",
		"PipeWidth": "管徑寬度",
		"PipeHeight": "管徑高度",
		"CulvertNum": "涵管條數",
		"PMaterial": "管線材料",
		"StartDepth": "起點埋設深度(M)",
		"EndDepth": "終點埋設深度(M)",
		"PipeLength": "管線長度",
		"SetType": "管線型態",
		"UseStatus": "使用狀態",
		"DataStatus": "資料狀態",
		"Memo": "備註"
	}
	let layer = createEsriDynamicLayer('自來水管線', 'PubPipe', 3, pipeField)
    return layer
}

// 瓦斯管線
function get_ntpcgis_gas_pipeline(){
	let pipeField = {
		"OBJECTID": "流水號",
		"Sys_Key": "系統編號",
		"CreateTime": "建立時間",
		"LastModify": "修改時間",
		"ROW_STATUS": "使用狀態",
		"CategCode": "類別碼",
		"FacNum": "識別碼",
		"StartNum": "起點編號",
		"EndNum": "終點編號",
		"Organ": "管理單位",
		"OPCode": "作業分區",
		"BuildDat": "設置日期",
		"PipeID": "管線編號",
		"SizeUnit": "尺寸單位",
		"PipeWidth": "管徑寬度",
		"PipeHeight": "管徑高度",
		"CulvertNum": "涵管條數",
		"PMaterial": "管線材料",
		"StartDepth": "起點埋設深度(M)",
		"EndDepth": "終點埋設深度(M)",
		"PipeLength": "管線長度",
		"SetType": "管線型態",
		"UseStatus": "使用狀態",
		"DataStatus": "資料狀態",
		"Memo": "備註"
	}
	let layer = createEsriDynamicLayer('瓦斯管線', 'PubPipe', 4, pipeField)
    return layer
}

// 輸油管線
function get_ntpcgis_oil_pipeline(){
	let pipeField = {
		"OBJECTID": "流水號",
		"Sys_Key": "系統編號",
		"CreateTime": "建立時間",
		"LastModify": "修改時間",
		"ROW_STATUS": "使用狀態",
		"CategCode": "類別碼",
		"FacNum": "識別碼",
		"StartNum": "起點編號",
		"EndNum": "終點編號",
		"Organ": "管理單位",
		"OPCode": "作業分區",
		"BuildDat": "設置日期",
		"PipeID": "管線編號",
		"SizeUnit": "尺寸單位",
		"PipeWidth": "管徑寬度",
		"PipeHeight": "管徑高度",
		"CulvertNum": "涵管條數",
		"PMaterial": "管線材料",
		"StartDepth": "起點埋設深度(M)",
		"EndDepth": "終點埋設深度(M)",
		"PipeLength": "管線長度",
		"SetType": "管線型態",
		"UseStatus": "使用狀態",
		"DataStatus": "資料狀態",
		"Memo": "備註"
	}
	let layer = createEsriDynamicLayer('輸油管線', 'PubPipe', 5, pipeField)
    return layer
}

// 供氣系統開關閥
function get_ntpcgis_gas_pipe_valve(){
	let pipeField = {
		"BaseHeight": "基礎高度",
		"BuildDate": "建造日期",
		"CategCode": "Categ代碼",
		"CORRECTION": "校正",
		"CoverType": "孔蓋類別",
		"CoverWidth": "孔蓋寬度",
		"CovHeight": "孔蓋高度",
		"CreateTime": "建立時間",
		"DataStatus": "資料狀態",
		"FacNum": "Fac號碼",
		"FID_Land": "FID_土地",
		"FID_RoadBlk": "FID_道路Blk",
		"HoleDepth": "孔洞深度",
		"HoleID": "孔洞編號",
		"LastModify": "最後修改",
		"Memo": "備註",
		"MendTime": "時間",
		"OPCode": "作業區分",
		"Organ": "單位",
		"PContent": "內容物",
		"ROW_STATUS": "狀態",
		"SetType": "類型",
		"SizeUnit": "尺寸",
		"STATE": "狀態",
		"Sys_Key": "代碼",
		"TCode": "編碼",
		"UseStatus": "使用狀態",
		"ZValueInfo": "Z值資訊"
	}
    let layer = createEsriDynamicLayer('供氣系統開關閥', 'PubPipe', 25, pipeField)
    return layer
}

// 供氣系統其他設施
function get_ntpcgis_gas_pipe_other(){
	let pipeField = {
		"BaseHeight": "基礎高度",
		"BuildDate": "建造日期",
		"CategCode": "Categ代碼",
		"CORRECTION": "校正",
		"CoverType": "孔蓋類別",
		"CoverWidth": "孔蓋寬度",
		"CovHeight": "孔蓋高度",
		"CreateTime": "建立時間",
		"DataStatus": "資料狀態",
		"FacNum": "Fac號碼",
		"FID_Land": "FID_土地",
		"FID_RoadBlk": "FID_道路Blk",
		"HoleDepth": "孔洞深度",
		"HoleID": "孔洞編號",
		"LastModify": "最後修改",
		"Memo": "備註",
		"MendTime": "時間",
		"OPCode": "作業區分",
		"Organ": "單位",
		"PContent": "內容物",
		"ROW_STATUS": "狀態",
		"SetType": "類型",
		"SizeUnit": "尺寸",
		"STATE": "狀態",
		"Sys_Key": "代碼",
		"TCode": "編碼",
		"UseStatus": "使用狀態",
		"ZValueInfo": "Z值資訊"
	}
    let layer = createEsriDynamicLayer('供氣系統其他設施', 'PubPipe', 26, pipeField)
    return layer
}

// 供氣系統場站
function get_ntpcgis_gas_pipe_station(){
	let pipeField = {
		"BaseHeight": "基礎高度",
		"BuildDate": "建造日期",
		"CategCode": "Categ代碼",
		"CORRECTION": "校正",
		"CoverType": "孔蓋類別",
		"CoverWidth": "孔蓋寬度",
		"CovHeight": "孔蓋高度",
		"CreateTime": "建立時間",
		"DataStatus": "資料狀態",
		"FacNum": "Fac號碼",
		"FID_Land": "FID_土地",
		"FID_RoadBlk": "FID_道路Blk",
		"HoleDepth": "孔洞深度",
		"HoleID": "孔洞編號",
		"LastModify": "最後修改",
		"Memo": "備註",
		"MendTime": "時間",
		"OPCode": "作業區分",
		"Organ": "單位",
		"PContent": "內容物",
		"ROW_STATUS": "狀態",
		"SetType": "類型",
		"SizeUnit": "尺寸",
		"STATE": "狀態",
		"Sys_Key": "代碼",
		"TCode": "編碼",
		"UseStatus": "使用狀態",
		"ZValueInfo": "Z值資訊"
	}
    let layer = createEsriDynamicLayer('供氣系統場站', 'PubPipe', 27, pipeField)
    return layer
}